/**
 * Preferences are keyed by portal so Air Admin / Teacher prefs don't leak into
 * School Admin (including when impersonating).
 *
 * School Admin defaults collapsed; Admin/Teacher defaults expanded.
 */
export const SIDEBAR_COLLAPSED_SCHOOL_ADMIN_KEY = 'sidebar-collapsed:school-admin';
export const SIDEBAR_COLLAPSED_ADMIN_TEACHER_KEY = 'sidebar-collapsed:admin-teacher';

export const SIDEBAR_WIDTH_EXPANDED = '15rem';
/** Narrow enough for icon-only nav; wide enough for the avatar footer. */
export const SIDEBAR_WIDTH_COLLAPSED = '5rem';
